import React from "react";
import { motion } from "framer-motion";
import { startCheckout } from "@/lib/checkout";
import { ArrowRight } from "lucide-react";

export default function MensalaoSection() {
  return (
    <section id="mensalao" className="relative py-24 md:py-36 bg-[#070707] border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=1800&q=80"
          alt=""
          className="w-full h-full object-cover"
          style={{ filter: "grayscale(100%) contrast(1.2) brightness(0.4)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/60 to-black" />
      </div>

      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[1px] w-10 bg-red-600" />
            <span className="eyebrow">Dossiê · Capítulo 01 · 2005</span>
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="font-display font-black leading-[0.9] tracking-[-0.03em] text-5xl md:text-7xl lg:text-8xl text-neutral-50"
          >
            Mensalão — o escândalo que{" "}
            <span className="text-red-600 italic">abalou Brasília</span>.
          </motion.h2>
          <p className="mt-8 max-w-xl text-neutral-400 leading-relaxed">
            O capítulo reconstrói o contexto político do primeiro mandato, as revelações da crise,
            a Ação Penal 470, o julgamento no STF e os desdobramentos políticos e jurídicos. Fatos,
            acusações e decisões são apresentados de forma separada.
          </p>

          <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3 font-mono text-[11px] tracking-[0.2em] uppercase text-neutral-400">
            {["Contexto político", "Investigações", "Ação Penal 470", "Desdobramentos"].map((x, i) => (
              <li key={x} className="flex items-center gap-3 border-l border-red-600 pl-3">
                <span className="text-red-500">0{i + 1}</span>
                {x}
              </li>
            ))}
          </ul>

          <button
            onClick={startCheckout}
            className="mt-10 inline-flex items-center gap-3 border border-white/15 hover:border-red-600 hover:text-red-500 text-neutral-200 h-12 px-6 font-mono tracking-[0.25em] text-[11px] uppercase transition-colors"
          >
            Ler o capítulo completo <ArrowRight className="h-4 w-4" />
          </button>
        </div>

        {/* Investigation board */}
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] border border-white/10 bg-[#0a0a0a] p-6 overflow-hidden">
            <div className="absolute top-4 right-4 h-14 w-14 border-2 border-red-600 rotate-6 text-red-500 font-mono text-[9px] tracking-widest flex items-center justify-center text-center">
              DOC<br/>RES
            </div>
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-red-500 mb-6">
              Prova anexa · Vol. 01
            </div>
            <div className="relative h-[85%]">
              {[
                { t: "AP 470", x: "10%", y: "10%", d: "STF · 2012" },
                { t: "Depoimentos", x: "55%", y: "25%", d: "Autos processuais" },
                { t: "Imprensa", x: "15%", y: "55%", d: "Veja · Folha · Estadão" },
                { t: "Condenações", x: "60%", y: "70%", d: "Cúpula política" },
              ].map((n, i) => (
                <div
                  key={i}
                  className="absolute px-3 py-2 bg-neutral-900 border border-red-600/60 rotate-[-2deg] text-neutral-200 text-[11px]"
                  style={{ left: n.x, top: n.y }}
                >
                  <div className="font-display font-bold">{n.t}</div>
                  <div className="font-mono text-[9px] text-neutral-500">{n.d}</div>
                </div>
              ))}
              {/* Lines */}
              <svg viewBox="0 0 400 400" className="absolute inset-0 w-full h-full">
                <line x1="80" y1="60" x2="260" y2="130" stroke="#dc2626" strokeWidth="1" strokeDasharray="3 3" />
                <line x1="80" y1="60" x2="90" y2="235" stroke="#dc2626" strokeWidth="1" strokeDasharray="3 3" />
                <line x1="260" y1="130" x2="270" y2="295" stroke="#dc2626" strokeWidth="1" strokeDasharray="3 3" />
                <line x1="90" y1="235" x2="270" y2="295" stroke="#dc2626" strokeWidth="1" strokeDasharray="3 3" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
